import {
    AUTH_STATUS_CHANGED,
} from 'shared_redux/actions';

export const authStatusChanged = (user) => ({ type: AUTH_STATUS_CHANGED, user });
